<template>
  <a-card>
    <div id="components-form-demo-advanced-search">
      <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">

        <a-row >
          <a-col :md="8" :sm="24" >
            <a-form-item
              :label= "$t('message.form.fulfillment.fulfillmentOrderId')"
              :labelCol="{span: 8}"
            >
              <a-input :placeholder="$t('message.common.input')" v-model="orderForm.orderFulfillmentOrderId" />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24" >
            <a-form-item
              :label="$t('message.form.fulfillment.tradeOrderId')"
              :labelCol="{span: 8}"
            >
              <a-input :placeholder="$t('message.common.input')" v-model="orderForm.orderTradeOrderId" />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24" >
            <a-form-item
              :label="$t('message.form.fulfillment.tradeCreateTime')"
              :labelCol="{span: 8}"
            >
              <a-range-picker 
                :value="createTimeRangeArray" 
                v-decorator="['createTime',{
                  initialValue:defaultTime
                }]"
                :format="dateFormat"
                @change="onChange" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row >
          <a-col :md="8" :sm="24" >
            <a-form-item
              :label="$t('message.form.fulfillment.orderStatus')"
              :labelCol="{span: 8}"
            >
              <a-select :placeholder="$t('message.common.select')" v-model="orderForm.orderStatus" :options="orderStatusList" allowClear >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24" >
            <a-form-item
              :label="$t('message.form.fulfillment.merchantList')"
              :labelCol="{span: 8}"
            >
              <a-select :placeholder="$t('message.common.select')" v-model="orderForm.merchantCode" @change="handleMerchantChange" allowClear>
                <a-select-option v-for="merchant in merchantList" :key="merchant.value">
                  {{ merchant.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24" >
            <a-form-item
              :label="$t('message.form.fulfillment.siteList')"
              :labelCol="{span: 8}"
            >
              <a-select :placeholder="$t('message.common.select')" v-model="orderForm.siteId" :options="siteList" allowClear>
                <a-select-option v-for="site in siteList" :key="site.value">
                  {{ site.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row >
          <a-col :md="8" :sm="24" >
            <a-form-item
              :label="$t('message.form.fulfillment.shippingTypeDesc')"
              :labelCol="{span: 8}"
            >
              <a-select :placeholder="$t('message.common.select')" v-model="orderForm.orderShippingType" :options="orderShippingTypeList" allowClear >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24" >
            <a-form-item
              :label="$t('message.form.fulfillment.warehouseCode')"
              :labelCol="{span: 8}"
            >
              <a-input style="width: 100%" :placeholder="$t('message.common.input')" v-model="orderForm.warehouseCode" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <span style="float: right; margin-top: 2px;">
            <a-button @click="handleSearch" type="primary">{{$t('message.common.search')}}</a-button>
            <a-button @click="resetBtnClick" style="margin-left: 8px">{{$t('message.common.reset')}}</a-button>
          </span>
        </a-row>
      </a-form>
      <br>
      <a-space>
        <a-dropdown>
          <a-menu @click="handlePrint" slot="overlay">
            <a-menu-item key="printPdf" :disabled="printPdfDisable">{{$t('message.button.printPdf')}}</a-menu-item>
          </a-menu>
          <a-button>
            {{$t('message.button.print')}}
            <a-icon type="down"/>
          </a-button>
        </a-dropdown>
        <a-button @click="showBatchShipping">
            {{$t('message.drawer.fulfillment.ship')}}
        </a-button>
        <a-dropdown>
          <a-menu @click="handleExportClick" slot="overlay">
            <a-menu-item key="export">{{$t('message.button.orderExport')}}</a-menu-item>
          </a-menu>
          <a-button>
            {{$t('message.button.export')}}
            <a-icon type="down"/>
          </a-button>
        </a-dropdown>
      </a-space>


      <!--数据表格展示位置-->
      <a-table :columns="columns" :rowKey="(record)=>{return record}" :dataSource="dataSource"  :pagination="pagination" :loading="loading" @change="getTableData"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :scroll="{ x: 'max-content'}"
               :expanded-row-keys.sync="expandedRowKeys"
      >
        <template slot="action" slot-scope="text,record">
          <a slot="action"  href="javascript:;" @click="showOrderDetail(record.orderFulfillmentOrderId, record.orderSiteId,
            record.merchantCode)">{{$t('message.common.detail')}}</a>
          <template v-if="record.orderItemStatus <= 110 && record.orderItemStatus >= 0 && record.orderShippingType == 200 && record.merchantCode != 'LAZADA'">
            <a-divider type="vertical"/>
            <a slot="action" href="javascript:;" @click="openShipFulfillmentOrder(record)">{{$t('message.common.fulfillment.ship')}}</a>
          </template>
          <template v-if="record.orderItemStatus <= 110 && record.orderItemStatus >= 0 && record.orderShippingType == 200 && record.merchantCode == 'LAZADA'">
            <a-divider type="vertical"/>
            <a slot="action" href="javascript:;" @click="openLazadaShipFulfillmentOrder(record)">{{$t('message.common.fulfillment.ship')}}</a>
          </template>
          <template v-if="record.orderItemStatus >= 700 && record.orderItemStatus <= 810 && record.orderShippingType == 200 && record.merchantCode != 'LAZADA'" >
            <a-divider type="vertical"/>
            <a slot="action"  href="javascript:;" @click="showDeliveryConfirm(record)">{{$t('message.common.fulfillment.deliveryConfirm')}}</a>
          </template>
        </template>
      </a-table>

      <div>
        <export-alert ref="exportAlert"></export-alert>
      </div>

      <a-drawer width="600" placement="right" :closable="true" :visible="shipVisible" @close="shipClose"
                style="font-weight: bold">
        <template>
          <div>
            <a-descriptions :title="$t('message.card.fulfillment.fulfillmentOrderInformation')" :size="size">
              <a-descriptions-item :label="$t('message.card.fulfillment.fulfillmentOrderId')" span="3">
                {{fulfillmentOrderId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.fulfillmentOrderItemId')" span="3">
                {{fulfillmentOrderItemId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradeOrderId')" span="3">
                {{tradeOrderId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradeOrderItemId')" span="3">
                {{tradeOrderItemId}}
              </a-descriptions-item>
            </a-descriptions>
            <br>

            <a-form :form="formShipping" @submit="handleSubmit">
              <a-form-item :label="$t('message.drawer.fulfillment.trackingNumbers')"
              >
                <a-input
                  v-decorator="['trackingNumbers', { rules: [{ required: true, message: this.$t('message.form.fulfillment.inputTrackingNumber') }] }]"
                  v-model="trackingNumber" />
              </a-form-item>

              <a-form-item :label="$t('message.drawer.fulfillment.shippingName')"
              >
                <a-input
                  v-decorator="['shippingName', { rules: [{ required: true, message: this.$t('message.form.fulfillment.inputShippingName') }] }]"
                  v-model="shippingName" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" html-type="submit" :loading="shipLoading">
                  {{$t('message.drawer.fulfillment.ship')}}
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </template>
      </a-drawer>

      <a-drawer width="600" placement="right" :closable="true" :visible="batchShipVisible" @close="batchShipClose"
                style="font-weight: bold">
        <template>
          <div>
            <a-form :form="formBatchShipping" @submit="handleBatchShippingSubmit">
              <a-form-item :label="$t('message.drawer.fulfillment.trackingNumbers')"
              >
                <a-input
                  v-decorator="['batchTrackingNumber', { rules: [{ required: true, message: this.$t('message.form.fulfillment.inputTrackingNumber') }] }]"
                  v-model="batchTrackingNumber" />
              </a-form-item>

              <a-form-item :label="$t('message.drawer.fulfillment.shippingName')"
              >
                <a-input
                  v-decorator="['batchShippingName', { rules: [{ required: true, message: this.$t('message.form.fulfillment.inputShippingName') }] }]"
                  v-model="batchShippingName" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" html-type="submit" :loading="batchShipLoading">
                  {{$t('message.drawer.fulfillment.ship')}}
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </template>
      </a-drawer>

      <a-drawer width="600" placement="right" :closable="true" :visible="deliveryCheckVisible" @close="deliveryCheckClose"
          style="font-weight: bold">
        <template>
          <div>
            <a-descriptions :title="$t('message.card.fulfillment.fulfillmentOrderInformation')" :size="size">
              <a-descriptions-item :label="$t('message.card.fulfillment.fulfillmentOrderId')" span="3">
                {{fulfillmentOrderId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.fulfillmentOrderItemId')" span="3">
                {{fulfillmentOrderItemId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradeOrderId')" span="3">
                {{tradeOrderId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradeOrderItemId')" span="3">
                {{tradeOrderItemId}}
              </a-descriptions-item>
            </a-descriptions>
            <br>

            <a-form :form="formDeliveryShipping" @submit="handleDeliveryCheckSubmit">
              <a-form-item :label="$t('message.form.fulfillment.deliveryType')">
                <a-select :placeholder="$t('message.common.select')" v-model="event">
                  <a-select-option value="DELIVERED">{{$t('message.select.fulfillment.deliverySuccess')}}</a-select-option>
                  <a-select-option value="DELIVERY_FAILED">{{$t('message.select.fulfillment.deliveryFailed')}}</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item>
                <a-button type="primary" html-type="submit" :loading="deliveryCheckLoading">
                  {{$t('message.common.commit')}}
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </template>
      </a-drawer>

      <a-drawer width="600" placement="right" :closable="true" :visible="batchDeliveryCheckVisible" @close="batchDeliveryCheckClose"
          style="font-weight: bold">
        <template>
          <div>
            <a-form :form="formBatchDelivery" @submit="handleBatchShippingSubmit">
              <a-form-item :label="$t('message.form.fulfillment.deliveryType')">
                <a-select :placeholder="$t('message.common.select')" v-model="event">
                  <a-select-option value="DELIVERED">{{$t('message.select.fulfillment.deliverySuccess')}}</a-select-option>
                  <a-select-option value="DELIVERY_FAILED">{{$t('message.select.fulfillment.deliveryFailed')}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" html-type="submit" :loading="batchDeliveryCheckLoading">
                  {{$t('message.common.commit')}}
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </template>
      </a-drawer>

      <a-drawer width="600" placement="right" :closable="true" :visible="packageVisible" @close="packageClose"
                style="font-weight: bold">
        <template>
          <div>
            <a-descriptions :title="$t('message.card.fulfillment.fulfillmentOrderInformation')" :size="size">
              <a-descriptions-item :label="$t('message.card.fulfillment.fulfillmentOrderId')" span="3">
                {{fulfillmentOrderId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.fulfillmentOrderItemId')" span="3">
                {{fulfillmentOrderItemId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradeOrderId')" span="3">
                {{tradeOrderId}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.card.fulfillment.tradeOrderItemId')" span="3">
                {{tradeOrderItemId}}
              </a-descriptions-item>
            </a-descriptions>
            <br>

            <a-form :form="formPackage" @submit="handlePackage">
              <a-form-item :label="$t('message.form.fulfillment.plName')">
                <a-select :placeholder="$t('message.common.select')" v-model="plName" :options="shipmentProviderList">
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" html-type="submit" :loading="packageLoading">
                  {{$t('message.drawer.fulfillment.ship')}}
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </template>
      </a-drawer>

      <a-drawer width="600" placement="right" :closable="true" :visible="batchPackageVisible" @close="batchPackageClose"
          style="font-weight: bold">
        <template>
          <div>
            <a-form :form="formBatchPackage" @submit="handleBatchPackage">
              <a-form-item :label="$t('message.form.fulfillment.plName')">
                <a-select :placeholder="$t('message.common.select')" v-model="plName" :options="shipmentProviderList">
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" html-type="submit" :loading="batchPackageLoading">
                  {{$t('message.drawer.fulfillment.ship')}}
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </template>
      </a-drawer>
    </div>

  </a-card>
</template>
<script>
  import request from '../../utils/request'
  import Form from 'ant-design-vue/lib/form'
  import {OrderApi} from '../../js/OrderApi'
  import moment from 'moment';
  import { Modal } from 'ant-design-vue';

  export default {
    computed: {
      columns () {
        return [
          {
            title: this.$t('message.table.fulfillment.fulfillmentOrderId'),
            width: 150,
            dataIndex: 'orderFulfillmentOrderId',
            render: (text, row, index) => {
              console.log(text, row);
              if (text == 'null') {
                return '';
              }
            },
            fixed: 'left',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.fulfillmentOrderItemId'),
            width: 150,
            dataIndex: 'fulfillmentOrderItemId',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.tradeOrderId'),
            width: 150,
            dataIndex: 'orderTradeOrderId',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.tradeOrderItemId'),
            width: 150,
            dataIndex: 'tradeOrderItemId',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.merchantCode'),
            width: 100,
            dataIndex: 'merchantName',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.siteId'),
            width: 100,
            dataIndex: 'siteName',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.orderStatusDesc'),
            width: 100,
            dataIndex: 'orderStatusDesc',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.orderItemStatusDesc'),
            width: 100,
            dataIndex: 'orderItemStatusDesc',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.shippingTypeDesc'),
            width: 100,
            dataIndex: 'orderShippingTypeDesc',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.cod'),
            width: 100,
            dataIndex: 'cod',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.buyerName'),
            width: 100,
            dataIndex: 'orderBuyerName',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.sellerName'),
            width: 100,
            dataIndex: 'sellerName',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.warehouseCode'),
            width: 150,
            dataIndex: 'warehouseCode',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.warehouseName'),
            width: 150,
            dataIndex: 'warehouseName',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.sellerSku'),
            width: 150,
            dataIndex: 'sellerSku',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.tradeCreateTime'),
            width: 150,
            dataIndex: 'tradeCreateTime',
            ellipsis: true
          },
          {
            title: this.$t('message.table.fulfillment.action'),
            width: 200,
            scopedSlots: {customRender: 'action'},
            fixed: 'right'
          }
        ]
      },
      defaultTime() {
        if (this.tradeStartTime === '' || this.tradeStartTime === '') return []    //
        return [moment(this.tradeStartTime, 'YYYY-MM-DD HH:mm:ss'), moment(this.tradeStartTime, 'YYYY-MM-DD HH:mm:ss')]
      }
    },
    data() {
      return {
        fulfillmentOrderId : '',
        fulfillmentOrderItemId : '',
        tradeOrderId : '',
        tradeOrderItemId : '',
        trackingNumber : '',
        shippingName : '',
        drawShippingType: '',
        sellerId : '',
        createTimeRangeArray:[],
        orderStatusList:[],
        pagination: {
          defaultPageSize: 10,
          current: 1,
          pageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20'],
          showTotal: total => `Total ${total} orders`,
          onShowSizeChange: (current, pageSize) => {
            console.log(current, pageSize);
            this.pagination.pageSize = pageSize;
          },
          total: 0,
          onChange: current => {
            // 切换分页时的回调，
            this.pagination.current = current;
            console.log('change current=', this.pagination.current);
            this.getTableData();
          }
        },
        rowKey: 'id',
        loading: true,
        dataSource: this.dataSource,
        selectedRowKeys: [], // Check here to configure the default column
        expandedRowKeys: [],
        expiredOrderDialog:{
          visible: false,
          confirmLoading: false,
        },
        orderForm:OrderApi.orderFromRequest,
        orderFulfillmentOrderId: '',
        orderTradeOrderId: '',
        orderReverseTradeOrderId: '',
        warehouseCode: '',
        orderStatus: '',
        orderShippingType: '',
        merchantCode: '',
        tradeStartTime: moment().format('YYYY-MM-DD' + ' 00:00:00'),
        tradeEndTime: moment().format('YYYY-MM-DD' + ' 23:59:59'),
        expand: false,
        shipVisible: false,
        batchShipVisible: false,
        deliveryCheckVisible: false,
        batchDeliveryCheckVisible: false,
        packageVisible: false,
        buyerId: '',
        cod:'',
        siteId: '',
        event: '',
        plName: '',
        pdfUrl: '',
        shipmentProviderList:[],
        dateFormat: 'YYYY-MM-DD HH:mm:ss',
        printPdfDisable: false,
        form: this.$form.createForm(this, { name: 'advanced_search' }),
        shipLoading: false,
        batchShipLoading: false,
        deliveryCheckLoading: false,
        batchDeliveryCheckLoading: false,
        packageLoading: false,
        batchPackageLoading: false,
        fulfillmentOrderExport: {
          orderFulfillmentOrderId: null,
          orderTradeOrderId: null,
          orderReverseTradeOrderId: null,
          warehouseCode: null,
          orderSiteId: null,
          orderStatus: null,
          orderShippingType: null,
          merchantCode: null,
          tradeStartTime: null,
          tradeEndTime: null,
          pageSize: null,
          pageIndex: null
        },
        merchantList: [],
        siteList: []
      };
    },
    created() {
      this.initOrderData();
      this.getTableData();
      this.selectedRowKeys = [];
    },
    beforeCreate () {
      this.formShipping = Form.createForm(this, 'filter-formShipping');
      this.formBatchShipping = Form.createForm(this, 'filter-formBatchShipping');
      this.formDeliveryShipping = Form.createForm(this, 'filter-formDeliveryShipping');
      this.formBatchDelivery = Form.createForm(this, 'filter-formBatchDelivery');
      this.formPackage = Form.createForm(this, 'filter-formPackage');
      this.formBatchPackage = Form.createForm(this, 'filter-formBatchPackage');
    },
    methods: {
      onChange(date, dateString) {
        this.createTimeRangeArray = date;
        //为变量赋值
        this.tradeStartTime = dateString[0];
        this.tradeEndTime = dateString[1];
      },
      handleSearch(e) {
        this.getTableDataBySearch();
      },
      addExpiredTime() {
        this.expiredOrderDialog.visible = true;

      },
      addNewOrderHandleOk() {
        console.log("开始ajax请求后台进行上传操作")
      },
      exportOrderHandleChange(info) {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          console.info(info.fileList[0].response)
          //获取到响应后，可以为全局变量赋值
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} file upload failed.`);
        }
      },
      handleExportClick (e) {
        if (e.key === 'import') {

        } else if (e.key === 'export') {
          this.fulfillmentOrderExport.orderFulfillmentOrderId = this.orderForm.orderFulfillmentOrderId;
          this.fulfillmentOrderExport.orderTradeOrderId = this.orderForm.orderTradeOrderId;
          this.fulfillmentOrderExport.orderReverseTradeOrderId = this.orderForm.orderReverseTradeOrderId;
          this.fulfillmentOrderExport.warehouseCode = this.orderForm.warehouseCode;
          this.fulfillmentOrderExport.orderStatus = this.orderForm.orderStatus;
          this.fulfillmentOrderExport.orderShippingType = this.orderForm.orderShippingType;
          this.fulfillmentOrderExport.merchantCode = this.orderForm.merchantCode;
          this.fulfillmentOrderExport.orderSiteId = this.orderForm.siteId;
          this.fulfillmentOrderExport.tradeStartTime = this.tradeStartTime;
          this.fulfillmentOrderExport.tradeEndTime = this.tradeEndTime;
          this.fulfillmentOrderExport.pageSize = this.pagination.pageSize;
          this.fulfillmentOrderExport.pageIndex = this.pagination.current;
          console.log('fulfillmentOrderExport:' + this.fulfillmentOrderExport);
          this.$refs.exportAlert.exportFile(this.fulfillmentOrderExport, 1100)
        }
      },
      expiredNewOrderHandleOk(){

      },
      //表格选择事件
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
        this.printPdfDisable = false;
        for(var i=0;i<selectedRowKeys.length;i++){
          if (selectedRowKeys[i].merchantCode === "LAZADA") {
              if (selectedRowKeys[i].orderItemStatus < '120') {
                this.printPdfDisable = true;
                break;
              }
          }
          if (selectedRowKeys[i].merchantCode === "AEG") {
            this.printPdfDisable = true;
            break;
          }
        }
      },
      expiredNewOrderHandleCancel() {
        this.expiredOrderDialog.visible = false;
      },
      expiredTimeOnChange(date, dateString) {

      },
      showOrderDetail(orderFulfillmentOrderId, orderSiteId, merchantCode) {
        this.$router.push(
          {
            path: "/fulfillment/order/detail",
            query: {
                orderFulfillmentOrderId: orderFulfillmentOrderId,
                orderSiteId: orderSiteId,
                merchantCode: merchantCode
              }
          }
        );
      },
      handlePrint (e) {
        if (e.key == 'printPdf') {
          this.getPdf();
        }
      },
      openShipFulfillmentOrder(record) {
        this.fulfillmentOrderId = record.orderFulfillmentOrderId;
        this.fulfillmentOrderItemId = record.fulfillmentOrderItemId;
        this.tradeOrderId = record.orderTradeOrderId;
        this.tradeOrderItemId = record.tradeOrderItemId;
        this.sellerId = record.sellerId;
        this.merchantCode = record.merchantCode;
        this.buyerId = record.orderBuyerId;
        this.cod = record.cod;
        this.shipVisible = true;
        this.batchShipVisible = false;
        this.deliveryCheckVisible = false;
        this.siteId = record.orderSiteId;
        this.event = 'SHIPPING';
      },
      showDeliveryConfirm(record) {
        this.fulfillmentOrderId = record.orderFulfillmentOrderId;
        this.fulfillmentOrderItemId = record.fulfillmentOrderItemId;
        this.tradeOrderId = record.orderTradeOrderId;
        this.tradeOrderItemId = record.tradeOrderItemId;
        this.sellerId = record.sellerId;
        this.merchantCode = record.merchantCode;
        this.buyerId = record.orderBuyerId;
        this.cod = record.cod;
        this.shipVisible = false;
        this.batchShipVisible = false;
        this.deliveryCheckVisible = true;
        this.siteId = record.orderSiteId;
      },
      openLazadaShipFulfillmentOrder(record) {
        this.fulfillmentOrderId = record.orderFulfillmentOrderId;
        this.fulfillmentOrderItemId = record.fulfillmentOrderItemId;
        this.tradeOrderId = record.orderTradeOrderId;
        this.tradeOrderItemId = record.tradeOrderItemId;
        this.sellerId = record.sellerId;
        this.merchantCode = record.merchantCode;
        this.buyerId = record.orderBuyerId;
        this.cod = record.cod;
        this.shipVisible = false;
        this.batchShipVisible = false;
        this.deliveryCheckVisible = false;
        this.packageVisible = true;
        this.siteId = record.orderSiteId;
        this.event = 'SHIPPING';
        this.getShippingProvider();
      },
      shipClose() {
        this.shipVisible = false;
        this.event = '';
      },
      batchShipClose() {
        this.batchShipVisible = false;
        this.event = '';
      },
      deliveryCheckClose() {
        this.deliveryCheckVisible = false;
        this.event = '';
      },
      batchDeliveryCheckClose() {
        this.batchDeliveryCheckVisible = false;
        this.event = '';
      },
      packageClose() {
        this.packageVisible = false;
        this.event = '';
      },
      batchPackageClose() {
        this.batchPackageVisible = false;
        this.event = '';
      },
      resetBtnClick() {
        const orderFormVar = {
            orderFulfillmentOrderId: '',
            orderTradeOrderId: '',
            orderReverseTradeOrderId: '',
            warehouseCode: '',
            orderStatus: '',
            orderShippingType: '',
            merchantCode: '',
            tradeStartTime: '',
            tradeEndTime: '',
        };
        this.orderForm = orderFormVar;
        this.createTimeRangeArray=[];
      },
      initOrderData() {
        this.getOrderStatus();
        this.getShippingType();
        this.getMerchant();
      },
      getTableData() {
        this.loading = true;
        //ajax请求获取数据
        request({
          url: OrderApi.OrderFromUrl.queryFulfillmentOrderUrl,
          method: 'get',
          params: {
            orderFulfillmentOrderId: this.orderForm.orderFulfillmentOrderId,
            orderTradeOrderId: this.orderForm.orderTradeOrderId,
            orderReverseTradeOrderId: this.orderForm.orderReverseTradeOrderId,
            warehouseCode: this.orderForm.warehouseCode,
            orderStatus: this.orderForm.orderStatus,
            orderShippingType: this.orderForm.orderShippingType,
            merchantCode: this.orderForm.merchantCode,
            siteId: this.orderForm.siteId,
            tradeStartTime: this.tradeStartTime,
            tradeEndTime: this.tradeEndTime,
            pageSize: this.pagination.pageSize,
            pageIndex: this.pagination.current
          }
        }).then(response => {
          if (response.data.success) {
            this.dataSource = response.data.data;
            const pagination = { ...this.pagination };
            pagination.total = response.data.totalCount;
            this.pagination = pagination;
          } else{
            this.$message.error(response.data.errorMsg);
          }
          this.selectedRowKeys = [];
          this.loading = false;
        });
      },
      getTableDataBySearch() {
        this.loading = true;
        console.log("getTableDataBySearch");
        //ajax请求获取数据
        request({
          url: OrderApi.OrderFromUrl.queryFulfillmentOrderUrl,
          method: 'get',
          params: {
            orderFulfillmentOrderId: this.orderForm.orderFulfillmentOrderId,
            orderTradeOrderId: this.orderForm.orderTradeOrderId,
            orderReverseTradeOrderId: this.orderForm.orderReverseTradeOrderId,
            warehouseCode: this.orderForm.warehouseCode,
            orderStatus: this.orderForm.orderStatus,
            orderShippingType: this.orderForm.orderShippingType,
            merchantCode: this.orderForm.merchantCode,
            siteId: this.orderForm.siteId,
            tradeStartTime: this.tradeStartTime,
            tradeEndTime: this.tradeEndTime,
            pageSize: this.pagination.pageSize,
            pageIndex: 1
          }
        }).then(response => {
          if (response.data.success) {
            this.dataSource = response.data.data;
            const pagination = { ...this.pagination };
            pagination.total = response.data.totalCount;
            this.pagination = pagination;
          } else{
            this.$message.error(response.data.errorMsg);
          }
          this.selectedRowKeys = [];
          this.loading = false;
        });
      },
      getShippingProvider() {
        request({
          url:OrderApi.OrderFromUrl.queryShipmentProvider,
          method: 'get',
          params: {
            sellerId: this.sellerId,
            siteId: this.siteId
          }
        }).then(response => {
          console.log("getShippingProvider:" + response);
          this.shipmentProviderList = response.data.data.map(
            item => {
              return {
                label: item.name,
                value: item.name
              };
            });
        });
      },
      getPdf() {
        this.loading = true;
        //ajax请求获取数据
        request({
          url: OrderApi.OrderFromUrl.queryPdfUrl,
          method: 'post',
          data: JSON.stringify(this.selectedRowKeys),
          headers:{
              'Content-Type':'application/json;charset=UTF-8',
          }
        }).then(response => {
          if (response.data.success) {
            this.pdfUrl = response.data.data;
            this.pdfSuccess();
          } else{
            this.$message.error(response.data.errorMsg);
          }
          this.loading = false;
        });
      },
      getOrderStatus() {
        request({
          url:OrderApi.OrderFromUrl.queryFulfillmentStatus,
          // headers:{
          //   requestUserId:OrderApi.requestUserId
          // },
          method: 'get',
        }).then(response => {
          console.log(response);
          this.orderStatusList = response.data.data.map(
            item => {
              return {
                label: item.message,
                value: item.statusNumber
              };
            });
        });
      },
      getShippingType() {
        request({
          url:OrderApi.OrderFromUrl.queryFulfillmentShippingType,
          // headers:{
          //   requestUserId:OrderApi.requestUserId
          // },
          method: 'get',
        }).then(response => {
          console.log(response);
          this.orderShippingTypeList = response.data.data.map(
            item => {
              return {
                label: item.message,
                value: item.shippingTypeNumber
              };
            });
        });
      },
      getMerchant() {
        request({
          url:OrderApi.OrderFromUrl.queryMerchant,
          method: 'get',
        }).then(response => {
          console.log(response);
          this.merchantList = response.data.data.map(
            item => {
              return {
                label: item.merchantName,
                value: item.merchantCode
              };
            });
        });
      },
      getSite() {
        request({
          url:OrderApi.OrderFromUrl.querySiteList,
          method: 'get',
          params: {
            merchantCode: this.orderForm.merchantCode
          }
        }).then(response => {
          this.siteList = response.data.data.map(
            item => {
              return {
                label: item.siteName,
                value: item.siteId
              };
            });
        });
      },
      handleMerchantChange(value) {
        this.getSite();
      },
      pdfSuccess() {
        this.$success({
          title: this.$t('message.modal.pdfTitle'),
          // JSX support
          content: (
            <div>
              {
                <a href={this.pdfUrl} target="_blank">{this.$t('message.modal.pdfContext')}</a>
              }
            </div>
          ),
        });
      },
      handleSubmit(e) {
        e.preventDefault();
        this.formShipping.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values);
            this.fulfillmentOrderStatusUpdate()
          }
        })
      },
      handlePackage(e) {
        e.preventDefault();
          this.formPackage.validateFields((err, values) => {
            if (!err) {
              console.log('handlePackage Received values of form: ', values);
              this.fulfillmentOrderStatusUpdate()
            }
        })
      },
      handleBatchPackage(e) {
        e.preventDefault();
          this.formBatchPackage.validateFields((err, values) => {
            if (!err) {
              console.log('handleBatchPackage Received values of form: ', values);
              this.batchShipFulfillmentOrder()
            }
        })
      },
      handleBatchShippingSubmit(e) {
        e.preventDefault();
        this.formBatchShipping.validateFields((err, values) => {
          if (!err) {
            console.log('Received batch values of form: ', values);
            this.batchShipFulfillmentOrder()
          }
        })
      },
      handleDeliveryCheckSubmit(e) {
        e.preventDefault();
        this.formDeliveryShipping.validateFields((err, values) => {
          if (!err) {
            console.log('Received handleDeliveryCheckSubmit values of form: ', values);
            this.fulfillmentOrderStatusUpdate()
          }
        })
      },
      fulfillmentOrderStatusUpdate () {
        this.shipLoading = true;
        this.deliveryCheckLoading = true;
        this.packageLoading = true;
        request({
          url: OrderApi.OrderFromUrl.fulfillmentOrderStatusUpdate,
          method: 'post',
          params: {
            fulfillmentOrderId: this.fulfillmentOrderId,
            fulfillmentOrderItemId: this.fulfillmentOrderItemId,
            tradeOrderId: this.tradeOrderId,
            tradeOrderItemId: this.tradeOrderItemId,
            trackingNumber: this.trackingNumber,
            shippingName: this.shippingName,
            event: this.event,
            sellerId: this.sellerId,
            merchantCode: this.merchantCode,
            buyerId: this.buyerId,
            cod: this.cod,
            siteId: this.siteId,
            asc3PLName: this.plName,
            asc3PLId: this.plName
          }
        }).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              if (this.event == 'SHIPPING') {
                this.$message.info(this.$t('message.message.fulfillment.shippingSuccess'));
              }
              if (this.event == 'DELIVERED' || this.event == 'DELIVERY_FAILED') {
                this.$message.info(this.$t('message.message.fulfillment.deliveryConfirm'));
              }
              this.shipVisible = false;
              this.deliveryCheckVisible = false;
              this.packageVisible = false
            }
          } else{
            this.$message.error(response.data.errorMsg);
          }
          this.shipLoading = false;
          this.deliveryCheckLoading = false;
          this.packageLoading = false;
        });
      },
      batchShipFulfillmentOrder () {
        this.batchShipLoading = true;
        this.batchDeliveryCheckLoading = true;
        this.batchPackageLoading = true;
        request({
          url: OrderApi.OrderFromUrl.batchfillmentOrderStatusUpdate,
          method: 'post',
          data: {
            trackingNumber: this.batchTrackingNumber,
            shippingName: this.batchShippingName,
            event: this.event,
            asc3PLName: this.plName,
            asc3PLId: this.plName,
            list: this.selectedRowKeys
          }
        }).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              this.$message.info(this.$t('message.message.fulfillment.shippingSuccess'));
              this.batchPackageVisible = false;
              this.batchShipVisible = false;
            }
          } else{
            this.$message.error(response.data.errorMsg);
          }
          this.batchShipLoading = false;
          this.batchDeliveryCheckLoading = false;
          this.batchPackageLoading = false;
        });
      },
      batchDeliveryFulfillmentOrder () {
        request({
          url: OrderApi.OrderFromUrl.batchfillmentOrderStatusUpdate,
          method: 'post',
          params: {
            event: this.event,
            list: this.selectedRowKeys
          }
        }).then(response => {
          if (response.data.success) {
            if (response.data.data) {
              this.$message.info(this.$t('message.message.fulfillment.deliveryConfirm'));
              this.batchShipVisible = false;
            }
          } else{
            this.$message.error(response.data.errorMsg);
          }
          this.loading = false;
        });
      },
      showBatchShipping (e) {
        if (this.selectedRowKeys.length == 0) {
          this.$message.info(this.$t('message.message.fulfillment.chooseOneOrder'));
          return
        }
        const uniqueSelectedRowKeys = [...new Set(this.selectedRowKeys.map(item => item.merchantCode))];
        if (uniqueSelectedRowKeys.length == 1) {
          if (uniqueSelectedRowKeys[0] == "LAZADA") {
            this.shipVisible = false;
            this.batchPackageVisible = true;
            this.batchShipVisible = false;
            this.sellerId = this.selectedRowKeys[0].sellerId;
            this.siteId = this.selectedRowKeys[0].orderSiteId;
            this.getShippingProvider();
          }
          if (uniqueSelectedRowKeys[0] == "AEG") {
            this.shipVisible = false;
            this.batchShipVisible = true;
            this.batchPackageVisible = false;
          }
          this.event = 'SHIPPING';
        } else {
          this.$message.info(this.$t('message.message.fulfillment.batchShippingMessage'));
          return
        }
      },
      showBatchDeliverySuccess (e) {
        if (this.selectedRowKeys.length == 0) {
          this.$message.info(this.$t('message.message.fulfillment.chooseOneOrder'));
          return
        }
        this.shipVisible = false;
        this.batchShipVisible = false;
        this.batchDeliveryCheckVisible = true;
        this.event = 'DELIVERED';
      },
      showBatchDeliveryFailed (e) {
        if (this.selectedRowKeys.length == 0) {
          this.$message.info(this.$t('message.message.fulfillment.chooseOneOrder'));
          return
        }
        this.shipVisible = false;
        this.batchShipVisible = false;
        this.batchDeliveryCheckVisible = true;
        this.event = 'DELIVERY_FAILED';
      }
    },
  };
</script>


<style scoped>

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }
  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

  .notshow{
    display: none;
  }
  .editable-row-operations a {
    margin-right: 8px;
  }
  .ant-table td { white-space: nowrap; }

  .ant-form-item {
    margin-bottom: 9px !important;
  }
  .ant-form-item-with-help {
    margin-bottom: 0 !important;
  }
  .ant-form-item-explain,
  .ant-form-item-extra {
    min-height: 16px !important;
    line-height: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Fulfillment/Order.vue